import LocationAndStoresModal from 'components/GlobalModals/LocationAndStoresModal/LocationAndStoresModal';
import { withLocationAndStoresModal } from 'viewModel/globalModals/locationAndStoresModal/withLocationAndStoresModalProps';

export default withLocationAndStoresModal(LocationAndStoresModal);
